@if (!download() && !href()) {
    <button
        class="bazis-btn-native"
        part="native"
        tabindex="-1"
    >
        <span
            class="bazis-btn__inner"
            part="inner"
        >
            <slot name="icon-only"></slot>
            <slot name="start"></slot>
            <span class="bazis-btn__text_wrapped">
                <slot></slot>
            </span>
            <slot name="end"></slot>
        </span>
    </button>
} @else if (href()) {
    <a
        class="bazis-btn-native"
        part="native"
        [attr.href]="href()"
        [attr.target]="target()"
        [attr.download]="download()"
    >
        <span
            class="bazis-btn__inner"
            part="inner"
        >
            <slot name="icon-only"></slot>
            <slot name="start"></slot>
            <span class="bazis-btn__text_wrapped">
                <slot></slot>
            </span>
            <slot name="end"></slot>
        </span>
    </a>
}
